<article class="xr-card room-card">
  <div class="room-card__head">
    <h2 class="room-card__name">{{ room.name }}</h2>
    @switch (status) {
      @case ('busy') {
        <span class="xr-badge xr-badge--busy">{{ 'rooms_list.status_busy' | translate }}</span>
      }
      @case ('waiting') {
        <span class="xr-badge xr-badge--wait">{{ 'rooms_list.status_waiting' | translate }}</span>
      }
      @default {
        <span class="xr-badge xr-badge--off">{{ 'rooms_list.status_empty' | translate }}</span>
      }
    }
  </div>

  <p class="room-card__explain">
    {{ (status === 'busy' ? 'rooms_list.explain_busy' : status === 'waiting' ? 'rooms_list.explain_waiting' : 'rooms_list.explain_empty') | translate }}
  </p>

  <div class="room-card__technician">
    <span class="xr-avatar" aria-hidden="true">
      @if (room.technician?.avatar) {
        <img [src]="room.technician?.avatar" alt=""/>
      } @else {
        {{ initials }}
      }
    </span>
    <span class="room-card__technician-info">
      @if (room.technician) {
        <span class="room-card__technician-name">{{ room.technician.name }} {{ room.technician.lastname }}</span>
        @if (room.company?.name) {
          <span class="room-card__technician-line room-card__company">{{ room.company?.name }}</span>
        }
        @if (room.technician.email) {
          <span class="room-card__technician-line">{{ room.technician.email }}</span>
        }
        <span class="room-card__technician-line">
          @if (room.technician.phone) {
            {{ room.technician.prefix?.prefix }} {{ room.technician.phone }}
          } @else {
            {{ 'rooms_list.no_phone' | translate }}
          }
        </span>
      } @else {
        <span class="room-card__technician-name">{{ 'rooms_list.no_technician' | translate }}</span>
      }
    </span>
  </div>

  <div class="room-card__footer">
    <span class="room-card__people" [matTooltip]="'rooms.people_in_room' | translate" matTooltipClass="tooltip-centered">
      <i-tabler name="users" class="icon-16 d-flex" aria-hidden="true"></i-tabler>
      {{ 'rooms_list.people' | translate: { count: room.connectionNumber ?? 0 } }}
    </span>
    <span
      class="room-card__action"
      [matTooltip]="tooltipKey | translate"
      [matTooltipDisabled]="!disabledBTN || !tooltipKey"
      matTooltipClass="tooltip-centered"
    >
      <button
        type="button"
        class="xr-btn xr-btn--primary room-card__join"
        (click)="openRoom()"
        [disabled]="disabledBTN"
      >
        @if (disabledBTN) {
          {{ 'rooms_list.already_in_call' | translate }}
        } @else {
          {{ 'rooms_list.join' | translate }}
          <i-tabler name="arrow-right" class="icon-16 d-flex" aria-hidden="true"></i-tabler>
        }
      </button>
    </span>
  </div>
</article>
